module.exports = __webpack_public_path__ + "img/icon-04.c9eef8a2.png";